// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--ion-color-dark-background) !important;
}

.ion-content-splash {
  display: flex;
  flex-direction: column;
  height: 100%;
}

img {
  margin: 0;
}

p {
  font-size: 10px;
  color: var(--ion-color-light);
  margin: 0 !important;
}

@media screen and (max-height: 430px) {
  .splash-footer-mobile {
    position: relative !important;
    bottom: 12px !important;
    margin-top: 10px;
  }
}

.splash-footer-text {
  position: fixed;
  bottom: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.env-radio-group {
  width: 100%;
}

.env-button {
  text-align: center;
}

.env-input {
  background: #fff;
  text-align: center;
  width: 100%;
  margin-left: 0;
}

@media screen and (min-width: 768px) {
  .env-radio-group {
    width: 80%;
  }
  .env-button {
    text-align: center;
  }
  .env-input {
    background: #fff;
    text-align: center;
    width: 80%;
    margin-left: 10%;
  }
}
.row-logo {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.row-logo .img-logo {
  height: 140px;
  margin: 0;
}

.row-position-center {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* @media screen and (max-width: 499px) {
      flex-direction: column;
      display: flex;
      .card-parent {
          padding: 5px 0px;
      }
  }*/
}
.row-position-center .card-parent {
  display: flex;
  flex-grow: 1;
  margin-top: 20px;
}
.row-position-center .left-padding-0 {
  flex-grow: 1;
}
.row-position-center .left-padding-1 {
  flex-grow: 1;
  min-width: 3px;
  max-width: 15px;
}
.row-position-center .right-padding-0 {
  flex-grow: 1;
  min-width: 3px;
  max-width: 15px;
}
.row-position-center .right-padding-1 {
  flex-grow: 1;
}
.row-position-center ion-card {
  flex-grow: 0;
  width: 250px;
  background: transparent;
  border: 2px solid var(--ion-color-primary);
  cursor: pointer;
}
.row-position-center ion-card ion-card-header {
  padding: 8px;
}
.row-position-center ion-card ion-card-header ion-card-subtitle {
  font-size: 22px;
  font-family: var(--font-primary);
  white-space: nowrap;
}
.row-position-center ion-card ion-card-header ion-card-subtitle.ios {
  font-size: 16px;
}
.row-position-center ion-card ion-card-content {
  background-color: #23063C;
  padding: 0;
  height: 100%;
}
.row-position-center ion-card ion-card-content .image-container {
  display: grid;
  padding: 0;
  min-width: 30px;
}
.row-position-center ion-card ion-card-content .image-container img {
  margin-top: env(safe-area-inset-top);
  margin-bottom: 30px;
}
.row-position-center ion-card ion-card-content .image-container.widely {
  height: 44px;
  width: 190px;
}
.row-position-center ion-card ion-card-content .image-container.widely img.pa {
  height: 35px;
}
.row-position-center.mobile.from-portait ion-card {
  width: 160px;
  height: 160px;
}
.row-position-center.mobile.from-portait ion-card ion-card-content ion-row {
  display: flex;
  flex-direction: column;
  padding: 8px 0 0 0;
  justify-content: center;
  align-items: center;
}
.row-position-center.mobile.from-portait ion-card ion-card-content ion-row ion-col {
  flex-basis: auto;
}
.row-position-center.mobile.from-portait ion-card ion-card-content .image-container {
  display: block;
}
@media screen and (max-width: 540px) {
  .row-position-center ion-card {
    width: 160px;
    height: 160px;
  }
  .row-position-center ion-card ion-card-content ion-row {
    display: flex;
    flex-direction: column;
    padding: 8px 0 0 0;
    justify-content: center;
    align-items: center;
  }
  .row-position-center ion-card ion-card-content ion-row ion-col {
    flex-basis: auto;
  }
  .row-position-center ion-card ion-card-content .image-container {
    display: block;
  }
  .row-position-center .center-col {
    padding-top: 23px !important;
  }
}
@media screen and (max-width: 340px) {
  .row-position-center {
    align-items: center;
  }
  .row-position-center .left-padding-1 {
    flex-grow: 1;
    max-width: none;
  }
  .row-position-center .right-padding-0 {
    flex-grow: 1;
    max-width: none;
  }
  .row-position-center .card-parent {
    margin-bottom: 8px;
  }
}

.androidTextSize {
  font-size: 1em !important;
}

.img-logo {
  height: 140px;
  margin-bottom: 20px;
}

.center-col {
  justify-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/tabs/tab-landing/tab-landing.page.scss"],"names":[],"mappings":"AAAA;EACI,yDAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,eAAA;EACA,6BAAA;EACA,oBAAA;AACJ;;AAGI;EADJ;IAEQ,6BAAA;IACA,uBAAA;IACA,gBAAA;EACN;AACF;;AAEA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI;IACI,UAAA;EACN;EAEE;IACI,kBAAA;EAAN;EAGE;IACI,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,gBAAA;EADN;AACF;AAIA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAFJ;AAII;EACI,aAAA;EACA,SAAA;AAFR;;AAMA;EAEI,aAAA;EACA,qCAAA;EA0JA;;;;;;IAAA;AAvJJ;AADI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAGR;AAEI;EACI,YAAA;AAAR;AAGI;EACI,YAAA;EACA,cAAA;EACA,eAAA;AADR;AAII;EACI,YAAA;EACA,cAAA;EACA,eAAA;AAFR;AAKI;EACI,YAAA;AAHR;AAMI;EACI,YAAA;EACA,YAAA;EAEA,uBAAA;EACA,0CAAA;EACA,eAAA;AALR;AAOQ;EACI,YAAA;AALZ;AAOY;EACI,eAAA;EACA,gCAAA;EACA,mBAAA;AALhB;AAOgB;EACI,eAAA;AALpB;AAUQ;EACI,yBAAA;EACA,UAAA;EACA,YAAA;AARZ;AAUY;EACI,aAAA;EACA,UAAA;EACA,eAAA;AARhB;AAUgB;EACI,oCAAA;EACA,mBAAA;AARpB;AAWgB;EACI,YAAA;EACA,YAAA;AATpB;AAWoB;EACI,YAAA;AATxB;AAkBY;EACI,YAAA;EACA,aAAA;AAhBhB;AAmBoB;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAjBxB;AAmBwB;EACI,gBAAA;AAjB5B;AAqBoB;EACI,cAAA;AAnBxB;AA0BI;EACI;IACI,YAAA;IACA,aAAA;EAxBV;EA2Bc;IACI,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;EAzBlB;EA2BkB;IACI,gBAAA;EAzBtB;EA6Bc;IACI,cAAA;EA3BlB;EAgCM;IACI,4BAAA;EA9BV;AACF;AAiCI;EA1IJ;IA2IQ,mBAAA;EA9BN;EAgCM;IACI,YAAA;IACA,eAAA;EA9BV;EAiCM;IACI,YAAA;IACA,eAAA;EA/BV;EAkCM;IACI,kBAAA;EAhCV;AACF;;AA8CA;EACI,yBAAA;AA3CJ;;AA+CA;EACI,aAAA;EACA,mBAAA;AA5CJ;;AA+CA;EACI,qBAAA;AA5CJ","sourcesContent":["ion-content {\r\n    --background: var(--ion-color-dark-background) !important;\r\n}\r\n\r\n.ion-content-splash {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\nimg {\r\n    margin: 0;\r\n}\r\n\r\np {\r\n    font-size: 10px;\r\n    color: var(--ion-color-light);\r\n    margin: 0 !important;\r\n}\r\n\r\n.splash-footer-mobile {\r\n    @media screen and (max-height: 430px) {\r\n        position: relative !important;\r\n        bottom: 12px !important;\r\n        margin-top: 10px;\r\n    }\r\n}\r\n\r\n.splash-footer-text {\r\n    position: fixed;\r\n    bottom: 15px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.env-radio-group {\r\n    width: 100%;\r\n}\r\n\r\n.env-button {\r\n    text-align: center;\r\n}\r\n\r\n.env-input {\r\n    background: #fff;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-left: 0;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .env-radio-group {\r\n        width: 80%;\r\n    }\r\n\r\n    .env-button {\r\n        text-align: center;\r\n    }\r\n\r\n    .env-input {\r\n        background: #fff;\r\n        text-align: center;\r\n        width: 80%;\r\n        margin-left: 10%;\r\n    }\r\n}\r\n\r\n.row-logo {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 1;\r\n\r\n    .img-logo {\r\n        height: 140px;\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.row-position-center {\r\n    // justify-content: center;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n\r\n    .card-parent {\r\n        display: flex;\r\n        flex-grow: 1;\r\n        margin-top: 20px;\r\n        //To include ON in landing page style changes\r\n        //justify-content: center;\r\n    }\r\n\r\n    .left-padding-0 {\r\n        flex-grow: 1;\r\n    }\r\n\r\n    .left-padding-1 {\r\n        flex-grow: 1;\r\n        min-width: 3px;\r\n        max-width: 15px;\r\n    }\r\n\r\n    .right-padding-0 {\r\n        flex-grow: 1;\r\n        min-width: 3px;\r\n        max-width: 15px;\r\n    }\r\n\r\n    .right-padding-1 {\r\n        flex-grow: 1;\r\n    }\r\n\r\n    ion-card {\r\n        flex-grow: 0;\r\n        width: 250px;\r\n\r\n        background: transparent;\r\n        border: 2px solid var(--ion-color-primary);\r\n        cursor: pointer;\r\n\r\n        ion-card-header {\r\n            padding: 8px;\r\n\r\n            ion-card-subtitle {\r\n                font-size: 22px;\r\n                font-family: var(--font-primary);\r\n                white-space: nowrap;\r\n\r\n                &.ios {\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n        }\r\n\r\n        ion-card-content {\r\n            background-color: #23063C;\r\n            padding: 0;\r\n            height: 100%;\r\n\r\n            .image-container {\r\n                display: grid;\r\n                padding: 0;\r\n                min-width: 30px;\r\n\r\n                img {\r\n                    margin-top: env(safe-area-inset-top);\r\n                    margin-bottom: 30px;\r\n                }\r\n\r\n                &.widely {\r\n                    height: 44px;\r\n                    width: 190px;\r\n\r\n                    img.pa {\r\n                        height: 35px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.mobile {\r\n        &.from-portait {\r\n            ion-card {\r\n                width: 160px;\r\n                height: 160px;\r\n\r\n                ion-card-content {\r\n                    ion-row {\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        padding: 8px 0 0 0;\r\n                        justify-content: center;\r\n                        align-items: center;\r\n\r\n                        ion-col {\r\n                            flex-basis: auto;\r\n                        }\r\n                    }\r\n\r\n                    .image-container {\r\n                        display: block;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 540px) {\r\n        ion-card {\r\n            width: 160px;\r\n            height: 160px;\r\n\r\n            ion-card-content {\r\n                ion-row {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    padding: 8px 0 0 0;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n\r\n                    ion-col {\r\n                        flex-basis: auto;\r\n                    }\r\n                }\r\n\r\n                .image-container {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n\r\n        .center-col {\r\n            padding-top: 23px !important;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 340px) {\r\n        align-items: center;\r\n\r\n        .left-padding-1 {\r\n            flex-grow: 1;\r\n            max-width: none;\r\n        }\r\n\r\n        .right-padding-0 {\r\n            flex-grow: 1;\r\n            max-width: none;\r\n        }\r\n\r\n        .card-parent {\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n    }\r\n\r\n    /* @media screen and (max-width: 499px) {\r\n        flex-direction: column;\r\n        display: flex;\r\n        .card-parent {\r\n            padding: 5px 0px;\r\n        }\r\n    }*/\r\n\r\n}\r\n\r\n.androidTextSize {\r\n    font-size: calc(1em) !important;\r\n\r\n}\r\n\r\n.img-logo {\r\n    height: 140px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.center-col {\r\n    justify-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
